import { faAngleRight } from "@fortawesome/pro-regular-svg-icons";

import { Link } from "@aviary";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./BreadcrumbItem.styles";

interface Props {
  title: string;
  href: string;
}

const BreadcrumbItem = ({ title, href }: Props) => {
  return (
    <li css={styles.listItemStyles} data-testid="breadcrumb-item">
      <Link isColor="system" isUnderLined={false} to={href}>
        {title}
      </Link>
      <FontAwesomeIcon icon={faAngleRight} width={24} height={24} />
    </li>
  );
};

export { BreadcrumbItem };
